import type { NewsItem } from '@/types/content';

export const news: NewsItem[] = [
  {
    id: 'news-01',
    title: '「镜中旅馆」公布正式预告，三视角结构引发讨论',
    date: '2025-06-12',
    summary: '影片把全部场景放在同一间旅馆客房，用三位住客的视角反复讲述同一段相遇，预告片上线后迅速成为本月讨论度最高的条目。',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20still%20of%20a%20dim%20hotel%20corridor%20with%20mirrors%20and%20warm%20amber%20lamps%2C%20atmospheric%20haze%2C%20deep%20charcoal%20tones%2C%20fine%20film%20grain%2C%20moody%20low%20key%20lighting%2C%20no%20text&width=480&height=320&seq=at-news-mirror-hotel&orientation=landscape',
    relatedFilmId: 'mirror-hotel',
    tag: '新片动态',
  },
  {
    id: 'news-02',
    title: '冰岛作品「晨光之前」确认引进，保留原版片长',
    date: '2025-06-24',
    summary: '发行方确认影片将以 86 分钟原版片长呈现，不做剪辑调整，并附带导演关于极昼拍摄的手记。',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20still%20of%20a%20minimal%20nordic%20landscape%20with%20a%20small%20cabin%20and%20pale%20midnight%20sun%2C%20low%20mist%2C%20deep%20charcoal%20tones%2C%20fine%20film%20grain%2C%20moody%20low%20key%20lighting%2C%20no%20text&width=480&height=320&seq=at-news-before-dawn&orientation=landscape',
    relatedFilmId: 'before-dawn',
    tag: '发行消息',
  },
  {
    id: 'news-03',
    title: '「镜头之后」幕后纪实上线，聚焦剧组基层岗位',
    date: '2025-05-28',
    summary: '纪录片跟随三个制作周期，记录灯光、场务与后期岗位的日常工作，也记录他们对「被看见」这件事的看法。',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20still%20of%20a%20film%20set%20at%20night%20with%20a%20lighting%20rig%20silhouette%20and%20warm%20smoke%2C%20deep%20charcoal%20tones%2C%20fine%20film%20grain%2C%20moody%20low%20key%20lighting%2C%20no%20text&width=480&height=320&seq=at-news-behind-lens&orientation=landscape',
    relatedFilmId: 'behind-the-lens',
    tag: '专题',
  },
  {
    id: 'news-04',
    title: '录像带时代作品完成 2K 修复，「录像带时代」重映',
    date: '2025-04-30',
    summary: '修复团队保留了原始磁带噪点，只重新校准了色彩与声音，重映场次将在下月起陆续公布。',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20still%20of%20a%20vintage%20CRT%20television%20and%20video%20tapes%20in%20a%20dim%20room%20with%20dusty%20light%2C%20deep%20charcoal%20tones%2C%20fine%20film%20grain%2C%20moody%20low%20key%20lighting%2C%20no%20text&width=480&height=320&seq=at-news-video-era&orientation=landscape',
    relatedFilmId: 'video-era',
    tag: '修复重映',
  },
  {
    id: 'news-05',
    title: '独立单元公布片单，「无声告白」入选主竞赛',
    date: '2025-04-16',
    summary: '本届独立单元共收录 12 部作品，其中「无声告白」以手持长镜头与极简对白获得评审团提名。',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20still%20of%20two%20figures%20on%20a%20balcony%20at%20dusk%20with%20laundry%20lines%20and%20warm%20window%20light%2C%20deep%20charcoal%20tones%2C%20fine%20film%20grain%2C%20moody%20low%20key%20lighting%2C%20no%20text&width=480&height=320&seq=at-news-silent-confession&orientation=landscape',
    relatedFilmId: 'silent-confession',
    tag: '影展',
  },
  {
    id: 'news-06',
    title: '「她的自述」访谈全集释出，六位从业者完整口述',
    date: '2025-03-08',
    summary: '影片以固定机位记录六位受访者的自述，不做旁白引导，也不插入解释性画面，完整版时长 76 分钟。',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20still%20of%20an%20empty%20interview%20chair%20and%20a%20microphone%20stand%20under%20one%20soft%20key%20light%2C%20deep%20charcoal%20tones%2C%20fine%20film%20grain%2C%20moody%20low%20key%20lighting%2C%20no%20text&width=480&height=320&seq=at-news-her-account&orientation=landscape',
    relatedFilmId: 'her-account',
    tag: '访谈',
  },
];